import React, { ReactNode } from 'react';

interface props {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
}

export const CardHeader = ({ title, subtitle, icon }: props) => {
  return (
    <div className="mb-4 flex items-center gap-3">
      {icon && (
        <div className="p-2 neumorphism rounded-lg bg-zinc-100 dark:bg-zinc-800">
          {icon}
        </div>
      )}
      <div>
        <p className="text-sm font-medium">{title}</p>
        {subtitle && (
          <p className="text-xs text-zinc-500 dark:text-zinc-400">{subtitle}</p>
        )}
      </div>
    </div>
  );
};
